import React from 'react';
import cn from 'classnames';

import styles from './homes.button.module.css'
import color from '../../../../styles/color.module.css'

const HomesButton = ({text, type = 'gray', onClick}) => {
  return (
    <div
      className={cn(styles.container, {
        [color[type]]: type
      })}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

export default HomesButton;
